import { defineStore } from "pinia";

export const useDelegueStore = defineStore("delegue", {
  state: () => ({
    selectedVeterinarian: null,
  }),
  
  getters: {
    getSelectedVeterinarian: (state) => state.selectedVeterinarian,
    
    // Optional: Helper getters if needed
    hasSelectedVeterinarian: (state) => state.selectedVeterinarian !== null,
    
    getSelectedVeterinarianId: (state) => state.selectedVeterinarian?.id || null,
    
    getSelectedVeterinarianName: (state) => state.selectedVeterinarian?.fullName || null,
  },
  
  actions: {
    setSelectedVeterinarian(vet) {
      this.selectedVeterinarian = vet;
    },
    
    clearSelectedVeterinarian() {
      this.selectedVeterinarian = null;
    },
    
    // Optional: Helper method to check if a specific vet is selected
    isVeterinarianSelected(vetId) {
      return this.selectedVeterinarian?.id === vetId;
    },
    
    // Optional: Method to update specific properties of the selected vet
    updateSelectedVeterinarian(updates) {
      if (this.selectedVeterinarian) {
        this.selectedVeterinarian = { ...this.selectedVeterinarian, ...updates };
      }
    },
  },
  
  persist: true,
});